import { render, staticRenderFns } from "./NFTContent.vue?vue&type=template&id=c7495f8a&scoped=true"
import script from "./NFTContent.vue?vue&type=script&lang=js"
export * from "./NFTContent.vue?vue&type=script&lang=js"
import style0 from "./NFTContent.vue?vue&type=style&index=0&id=c7495f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7495f8a",
  null
  
)

export default component.exports